import { render, staticRenderFns } from "./EditPosterPopup.vue?vue&type=template&id=4878a87a&scoped=true"
import script from "./EditPosterPopup.vue?vue&type=script&lang=js"
export * from "./EditPosterPopup.vue?vue&type=script&lang=js"
import style0 from "./EditPosterPopup.vue?vue&type=style&index=0&id=4878a87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878a87a",
  null
  
)

export default component.exports